<template>
<div class="chapter">
<div class="inner_page">
<p class="ct" id="pz3-1" style="text-align:left; font-size: 2.3em;">
					Contents </p>
<p class="ctt" id="pz3-2">
<a href="#/whyruleofthumb#b1" id="a1"><b>Why Rule of Thumb?</b></a> </p>
<p class="ctt" id="pz3-4">
<b><a href="#/chapter01#b2" id="a2">Chapter 1:</a></b> </p>
<p class="ctt1" id="pz3-5">
<a href="#/chapter01#b3" id="a3">Sustaining a Small Business:</a> </p>
<p class="ctt1">
<a href="#/chapter01#b3">Getting Started What is Business Sustainability? </a></p>
<p class="ctt" id="pz3-7">
<b><span href="#/chapter02#b5" id="a5" title="Link target outside of Sample">Chapter 2:</span></b> </p>
<p class="ctt1" id="A0x">
<span href="#/chapter02#b6" id="a6" title="Link target outside of Sample">Sustaining a Small Business: Diversifying Revenues</span></p>
<p class="ctt1"><span href="#/chapter02#b7a" id="a7a" title="Link target outside of Sample">How Can I Diversify Business Revenues?
					</span></p>
<p class="ctt" id="pz3-11">
<b><span href="#/chapter03#b8" id="a8" title="Link target outside of Sample">Chapter 3:</span></b> </p>
<p class="ctt1" id="pz3-12">
<span href="#/chapter03#b9" id="a9" title="Link target outside of Sample">Sustaining a Small Business:</span></p>
<p class="ctt1"><span href="#/chapter03#b10a" title="Link target outside of Sample">Social Media Marketing</span></p>
<p class="ctt1"><span href="#/chapter03#b10a" id="a10a" title="Link target outside of Sample">What is Social Media Marketing? </span></p>
<p class="ctt" id="pz3-15">
<b><span href="#/chapter04#b11" id="a11" title="Link target outside of Sample">Chapter 4:</span></b> </p>
<p class="ctt1" id="pz3-16">
<span href="#/chapter04#b12" id="a12" title="Link target outside of Sample">Sustaining a Small Business: Branding </span></p>
<p class="ctt1">
<span href="#/chapter04#b12a" id="a12a" title="Link target outside of Sample">How Can I Brand My Small Business? </span></p>
<p class="ctt" id="pz3-20">
<b><span href="#/chapter05#b13" id="a13" title="Link target outside of Sample">Chapter 5:</span></b> </p>
<p class="ctt1" id="pz3-21">
<span href="#/chapter05#b14" id="a14" title="Link target outside of Sample">Sustaining a Small Business: Networking </span></p>
<p class="ctt1"><span href="#/chapter05#b14a" id="a14a" title="Link target outside of Sample">How Can I Use Networking to Increase Revenues?
					</span></p>
<p class="ctt" id="pz3-23">
<b><span href="#/chapter06#b15" id="a15" title="Link target outside of Sample">Chapter 6:</span></b> </p>
<p class="ctt1" id="pz3-24">
<span href="#/chapter06#b16" id="a16" title="Link target outside of Sample">Sustaining a Small Business:</span></p>
<p class="ctt1"><span href="#/chapter06#b17a" title="Link target outside of Sample">Contract Bidding Opportunities </span></p>
<p class="ctt1"><span href="#/chapter06#b17a" id="a17a" title="Link target outside of Sample">How Can I Use Contract Bidding to Increase Revenues?
					</span></p>
<p class="ctt" id="pz3-28">
<b><span href="#/chapter07#b18" id="a18" title="Link target outside of Sample">Chapter 7:</span></b> </p>
<p class="ctt1" id="pz3-29">
<span href="#/chapter07#b19" id="a19" title="Link target outside of Sample">Sustaining a Small Business: Finances </span></p>
<p class="ctt1"><span href="#/chapter07#b20" id="a20" title="Link target outside of Sample">How Can I Find Money for My Business?</span> </p>
<p class="ctt" id="pz4-1">
<b><span href="#/chapter08#b20a" id="a20a" title="Link target outside of Sample">Chapter 8:</span></b> </p>
<p class="ctt1" id="pz4-2">
<span href="#/chapter08#b21" id="a21" title="Link target outside of Sample">Sustaining a Small Business: Reinvention </span></p>
<p class="ctt1">
<span href="#/chapter08#b21a" id="a21a" title="Link target outside of Sample">How Can I Meet Emerging Service or Product
					Demands?</span> </p>
<p class="ctt" id="pz4-5">
<b><span href="#/chapter09#b22" id="a22" title="Link target outside of Sample">Chapter 9:</span></b> </p>
<p class="ctt1" id="pz4-6">
<span href="#/chapter09#b23" id="a23" title="Link target outside of Sample">Sustaining a Small Business: Succession </span></p>
<p class="ctt1">
<span href="#/chapter09#b30" id="a30" title="Link target outside of Sample">How Can I Plan for Succession? </span></p>
<p class="ctt" id="pz4-8">
<b><span href="#/Conquering#b24" id="a24" title="Link target outside of Sample">Conquering The Basics</span></b> </p>
<p class="ctt" id="pz4-9">
<b><span href="#/Additional#b25" id="a25" title="Link target outside of Sample">Additional Resources</span></b> </p>
<p class="ctt" id="pz4-10">
<b><span href="#/abouttheauthors#b26" id="a26" title="Link target outside of Sample">Author Biography</span></b> </p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?1ead3ce6